module.exports = __webpack_public_path__ + "assets/img/0804.ad6178ff.png";